module.exports = __webpack_public_path__ + "static/img/header_bg2.0a9dcae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/portrait/header/header_bg2.png
// module id = 0JML
// module chunks = 6